// extracted by mini-css-extract-plugin
module.exports = {"column":"fever-trends_column__25Wna","graph":"fever-trends_graph__1KBzS","detail":"fever-trends_detail__2wdxF","container":"fever-trends_container__1z8e5"};